import * as actionTypes from "actions";

const initialState = {
  Loading: false,
  llmList: [],
  llmPrompts: [],
  workspaceList: [],
  workspaceRecord: [],
  workspaceDropdownList: [],
  workspaceAttachmentList: [],
  validation_error: "",
  attachment_validation_error: "",
  workspace_form_validation_error: "",
  redirect_to_list: false,
  showDeleteModel: false,
  showUpdateForm: false,
  showViewPage: false,
};

const WorkspaceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.WORKSPACE_REQUEST:
      return {
        ...state,
        Loading: true,
        validation_error: "",
        redirect_to_list: false,
      };
    case actionTypes.WORKSPACE_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        workspaceList: action.workspaceList,
        showUpdateForm: false,
        showViewPage: false,
        workspaceRecord: [],
      };
    case actionTypes.WORKSPACE_SERVER_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        showUpdateForm: false,
        showViewPage: false,
        workspaceRecord: [],
      };
    case actionTypes.WORKSPACE_GET_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        workspaceRecord: action.record,
        showUpdateForm: action.actionType === "update" ? true : false,
        showViewPage: action.actionType === "view" ? true : false,
      };
    case actionTypes.WORKSPACE_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        Loading: false,
        workspaceDropdownList: action.workspaceDropdownList,
      };
    case actionTypes.WORKSPACE_VALIDATION_ERROR:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.HIDE_WORKSPACE_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key])
        delete state.validation_error[action.feild_key];
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.REDIRECT_TO_WORKSPACE_LIST:
      return {
        ...state,
        redirect_to_list: true,
        showUpdateForm: false,
        showViewPage: false,
        validation_error: "",
        workspaceRecord: [],
      };

    //workspace attachments
    case actionTypes.WORKSPACE_ATTACHMENT_VALIDATION_ERROR:
      return {
        ...state,
        Loading: false,
        attachment_validation_error: action.attachment_validation_error,
      };
    case actionTypes.WORKSPACE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        Loading: false,
        attachment_validation_error: "",
        workspaceAttachmentList: action.workspaceAttachmentList,
      };

      //workspace form
      case actionTypes.WORKSPACE_FORM_VALIDATION_ERROR:
        return {
          ...state,
          Loading: false,
          workspace_form_validation_error: action.workspace_form_validation_error,
        };

        case actionTypes.WORKSPACE_FORM_SUCCESS:
          return {
            ...state,
            Loading: false,
            workspace_form_validation_error: "",
            workspaceFormList: action.workspaceFormList,
          };

    case actionTypes.CHAT_GET_LLM_PROMPTS_SUCCESS:
      return {
        ...state,
        Loading: false,
        llmPrompts: action.llmPrompts,
      };

    case actionTypes.CHAT_GET_LLM_MODEL_SUCCESS:
      return {
        ...state,
        Loading: false,
        llmList: action.llmList,
      };
    default:
      return state;

   
  }
};

export default WorkspaceReducer;
